import React from 'react';
import { Slider, Row } from 'antd';
import { SliderMarks } from 'antd/lib/slider';

export interface IFormSlider {
	onChange: Function;
	value: number;
	min: number;
	max: number;
	marks: SliderMarks;
	label: string;
}
export const FormSlider = ({ onChange, value, min, max, marks, label }: IFormSlider) => {
	return (
		<>
			<div style={{ gridColumn: 1 }}>
				<strong>{label}</strong>
			</div>
			<div style={{ gridColumn: '2/6', paddingRight: 15 }}>
				<Row style={{ width: '100%' }}>
					<div style={{ width: '100%' }}>
						<Slider style={{ width: '100%' }} defaultValue={value} min={min} max={max} marks={marks} onChange={(value: any) => onChange(value)} />
					</div>
				</Row>
			</div>
		</>
	);
};
export default FormSlider;
